import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'accountNumber'})
export class AccountNumberPipe implements PipeTransform {

	transform(value: string) {
		if (value) {
			value = String(value);
			if (!value.includes('-'))
				value = value.replace(/(\d+)(\d)/, '$1-$2');
		}
		return value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/account-number.pipe.ts